import React, {Fragment} from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {Box, Typography} from '@material-ui/core';
import {EfeBullet} from 'components';
import {Utils} from 'commons';

function EfeBulletList(props: InferProps<typeof EfeBulletList.propTypes>) {
    const {bullets, handleAction, handleHeaderAction, style} = props;
    const onAction = (key: number) =>
        function (value: Record<string, unknown>) {
            if (handleAction) {
                handleAction(key, value);
            }
        };
    const onHeaderAction = (value: string) => {
        if (handleHeaderAction) {
            handleHeaderAction(value);
        }
    };
    const ListBullets = bullets.map((bullet, index) => {
        return (
            <Box
                key={Utils.functions.Generate.uniqueID()}
                mt={index > 0 ? 16 : 0}>
                <Typography variant={style !== 'none' ? 'caption' : 'body1'}>
                    {bullet.desc}
                </Typography>
                <ul
                    style={
                        bullet.secondaryLink ? {paddingLeft: '0'} : undefined
                    }>
                    {bullet.items.map((item) => {
                        if (bullet.secondaryLink) {
                            return (
                                <EfeBullet
                                    handleAction={onAction(index)}
                                    secondaryLink={bullet.secondaryLink}
                                    handleHeaderAction={onHeaderAction}
                                    key={Utils.functions.Generate.uniqueID()}
                                    item={item}
                                />
                            );
                        } else {
                            return (
                                <li key={Utils.functions.Generate.uniqueID()}>
                                    <EfeBullet
                                        handleAction={onAction(index)}
                                        secondaryLink={bullet.secondaryLink}
                                        handleHeaderAction={onHeaderAction}
                                        key={Utils.functions.Generate.uniqueID()}
                                        item={item}
                                    />
                                </li>
                            );
                        }
                    })}
                </ul>
            </Box>
        );
    });

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{ListBullets}</Fragment>;
}

EfeBulletList.propTypes = {
    bullets: PropTypes.arrayOf(
        PropTypes.shape({
            desc: PropTypes.string.isRequired,
            secondaryLink: PropTypes.bool,
            items: PropTypes.arrayOf(
                PropTypes.shape({
                    item: PropTypes.number.isRequired,
                    sections: PropTypes.arrayOf(
                        PropTypes.shape({
                            value: PropTypes.string.isRequired,
                            style: PropTypes.oneOf([
                                'help',
                                'body',
                                'strong',
                                'link',
                                'tooltip',
                                'caption',
                                'modal',
                            ]).isRequired,
                            order: PropTypes.number.isRequired,
                            text: PropTypes.string,
                        }).isRequired
                    ).isRequired,
                }).isRequired
            ).isRequired,
        }).isRequired
    ).isRequired,
    handleAction: PropTypes.func,
    handleHeaderAction: PropTypes.func,
    style: PropTypes.oneOf(['caption', 'none']).isRequired,
};

EfeBulletList.defaultProps = {
    style: 'none',
};

export default EfeBulletList;
